module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("One")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("H")])]), _vm._v("e wore his all-American good looks like a merit badge, but the devil in his dark eyes told Erin Brailey this man was no Boy Scout.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zach Miller strode through Erin’s office door with an athletic grace that immediately captured her imagination. Although some might deem his appearance inappropriate for a business meeting, she appreciated his chambray shirt and jeans. The clothes fit as if tailor-made to showcase his attributes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But no matter how perfect his layered black hair, how breathtaking his six-foot-plus frame, she refused to allow his presence to distract her. This was business. Maybe the most important business of her life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stepped to the side of her desk and offered him her hand and a smile. “Mr. Miller, I’m Erin Brailey, executive director of Rainbow Center. Thanks for coming in.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("“I’m glad to meet you, Ms. Brailey.” His strong, cal")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("lused hand gripped hers, complementing the rough timbre of his voice.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After he released her hand, Erin reclaimed her desk chair and motioned for him to take the seat across from her. Once he settled in, she flipped open a folder and scanned the information inside. “I guess you know we’ve accepted your bid.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not until now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she looked up, he was watching her, his bent elbow resting on the chair arm, finger and thumb forming an L-shaped support for his head from temple to jaw. His casual posture didn’t detract from his air of control.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Erin consulted the material again to avoid his steady scrutiny. She brushed her hair from her face and caught a whiff of his heady cologne lingering on her fingertips. “Since the center decided not to go public with sealed bids, I assumed we’d have to pay more for security.” After closing the file, she folded her hands in front of her and met his gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He leaned forward, his espresso eyes boring into her. “If you’re worried about getting your money’s worth, I guarantee you’ll be completely satisfied.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Although his expression didn’t change, Erin’s composure slipped a notch. If any other contractor had told her the same thing, she wouldn’t have given the words a second thought. But coming from this great-smelling man with the whisky voice and sinful eyes, she felt like the target of a drive-by, indecent proposal. One she might be tempted to accept.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shaking the ridiculous thoughts from her brain, Erin loosened her joined hands from their death grip and fought the urge to turn the thermostat down to sixty. The center couldn’t afford the extra electricity. Neither could she.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("“I’m not worried about the quality of your work,” she ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("said. “You come highly recommended by Gil Parks, and I trust his judgment. I’m simply trying to understand your motivation for accepting a job that might show little profit for your company.”")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zach sat back and scrubbed at his jaw with one hand. “Are you expecting an ‘I’m serving my community’ speech?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Erin tamped down the surge of anger. Long ago she had come to realize that not everyone was committed to the shelter and the issues it represented. “I’m expecting an honest answer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His lazy gaze took in the surroundings, the olive-green curtains, the marred oak desktop, the yellowed walls. He finally brought his eyes back to her. “I did my homework, Ms. Brailey. I know there’s a need for this new shelter. You can’t be too careful about the causes you support financially.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She supposed she should be flattered he’d chosen to bestow his selective altruism on Rainbow Center, but her cautious nature jumped into autopilot. “Phase II has been chosen to assist some of the larger municipalities because of its rural location. It will provide a totally secure environment dependent on private protection. We will require the utmost discretion since it’s designed to provide refuge for women whose batterers are high-profile or work within service occupations in the surrounding communities.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You mean cops.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("“Yes, law enforcement does fall under that umbrella along with paramedics, firemen and anyone else who would know the whereabouts of the existing shelters in their area. The house isn’t registered under the center’s name. Neither are the utilities. So for all intents and purposes, it will appear to be an isolated farmhouse sitting in ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("the middle of seventy-five acres. But we’ll still require private security since nothing is 100 percent foolproof.”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That makes sense.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something about Zach Miller’s frown bothered Erin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So, have you always worked in security?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shifted in the chair and rubbed one large hand down his jeans-clad thigh. “No. I used to be a cop.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Warning bells rang out in Erin’s brain. As the center’s staff accountant, Gil Parks was usually meticulous. Not this time. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Before")]), _vm._v(" Gil invited Zach Miller’s bid and convinced the board of directors to accept it, he should have brought this significant detail to Erin’s attention immediately despite the fact Zach was a long-time acquaintance and trusted friend of Gil’s. She was governed by the board—respected community leaders—and she’d worked hard to build their trust. She wouldn’t allow an error in judgment to destroy their faith in her and compromise the project. She had to know more about Zach Miller.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long were you in law enforcement?” she asked, trying to keep the concern from her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Twelve years total. Seven with Dallas PD, five right here in Langdon. I’ve been in the security business for three.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why did you leave the department?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Burnout.” Some unnamed emotion flared in his dark eyes, but it disappeared as quickly as it came.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Erin made a mental note to ask Gil for more details about Zach Miller’s departure from the force. “Do you still have contact with your former colleagues?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A few.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Feeling a headache coming on, Erin pinched the bridge of her nose. “I hope this isn’t going to be a problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you mean?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("She squared her shoulders and looked at him straight ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("on. “I know it’s rare, especially in a community the size of Langdon, but should the situation arise, are you going to be able to provide protection for beaten wives and girlfriends of law enforcement colleagues, then keep it a secret?”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He leaned forward, his dark eyes boring into her. “Are you asking can you trust me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. That’s exactly what I’m asking.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He remained the portrait of restraint, but Erin noted a flash of anger pass over his face. “Ms. Brailey, I have no problem protecting any woman from a man who thinks using her as a punching bag is his God-given right. Cop or no cop. And I’ve kept my share of secrets over the years.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She imagined he had. And probably still did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He folded his arms across his broad chest and resumed a relaxed position. “You can trust me. So can your residents.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hadn’t raised his voice, but the conviction in his tone spoke volumes. And if her instincts were correct, Erin suspected he was much more than just a burned-out cop. She also wondered if he had more commitment to this project than he cared to admit. Only time would tell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have to make sure we’re clear on this issue,” she said. “This is a pilot program. I have one more month to get it going. Our funding hinges on its success. If I can’t make it work, then it’s over before it gets a running start.” She drew in a breath. “This shelter is very important to many people.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And important to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her pride had given her away. “Yes. Me, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His grin came out of hiding. “Nothing wrong with that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Erin smiled back and added perfect teeth to her covert ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("list of his assets, then scolded herself for doing just that. Yet she couldn’t help but notice the sprinkling of crisp black hair peeking out from the opening in his shirt. She’d bet her meager salary he had a chest that wouldn’t quit.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zach Miller appeared to be a tough-around-the-edges man. A man her father would never approve of. Which made him all the more appealing to Erin. Unfortunately, he would have to remain off-limits. She didn’t have time for men. Or maybe she just didn’t have the fortitude to explore the possibilities, considering past experience. Although at the moment the thought was tempting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ms. Brailey?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her face flamed when she realized he’d been speaking. “I’m sorry. Just daydreaming.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Must’ve been one heck of a daydream.” His grin deepened, revealing a single dimple at the left corner of his mouth. A nice spot to kiss, Erin decided.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bolting from her chair, Erin sent the papers on her desk into a frenzied dance. “That about does it. I guess we’re settled and ready for you to get started.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His smile faded, but it didn’t detract from his brooding good looks. “Aren’t you coming with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her pulse did the cha-cha. “Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The new shelter. I worked the bid from a blueprint, so I haven’t actually seen it yet. If you have the time, I can show you some of what I have in mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thank heavens he didn’t know what she’d had in mind a minute ago. “You mean now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now is good for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If she thought he wouldn’t notice, Erin would kick herself in the backside with her black pumps for sounding so unnerved. “Sure. There’s nothing here that can’t wait.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Erin slipped her blazer on and grabbed her purse. Zach followed her to the reception desk where she addressed the ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("college student filling in for the summer. “Cathy, Mr. Miller and I are going to visit the new shelter.” She consulted her watch while the receptionist stared at Zach. “I may not be back, so forward all important calls to my home or page me.”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, ma’am,” Cathy said as she brought her gaze briefly to Erin, then back to Zach.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Erin headed toward the exit wondering if Cathy had heard a word she’d said. Obviously, the man had the same effect on women eighteen to sixty and all points in between.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luckily, Erin had grown immune to men too handsome for their own good. At least she thought she had. Until today.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Silence hung over the cab of the truck like the dust rising off the dash as Zach skirted one rural pothole after another. He hadn’t quite gotten over the impact of meeting Erin Brailey, five feet eight inches of pure fantasy—blond hair, blue eyes, with a body that could stop a high-stakes game of poker. Right now she afforded him a good view of her thighs where her tight black skirt had ridden up. He reminded himself to focus on the road and keep his libido in check.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In his peripheral vision, Zach saw Erin shimmy out of her jacket. He also noticed the way the white satin blouse clung to her round breasts. He tightened his grip on the steering wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you hot?” he asked with a cursory glance in her direction. He certainly was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s a little warm,” she answered. “Looks like it’s going to be a blistering Texas summer if May’s any indication.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Small talk. He could handle that. “I’ll turn up the air.”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he set the control all the way to high, a burst of cold air blew into his face, but it didn’t do much for the heat her presence had generated in his uncooperative body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How much farther?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Turn right in two miles, then it’s another eight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He started to ask how they chose the site, but his words died when he glimpsed her breasts again. Now she was cold. He silently cursed the fact the shelter was still ten minutes away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Clearing the uncomfortable hitch in his throat, he asked, “How long have you been working for Rainbow Center?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she crossed her arms over her chest, Zach was both disappointed and relieved. “I’ve been with the center since I started college,” she said. “I worked my way up to director while I completed my graduate studies.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In counseling?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have an MBA. I have a pretty good head for business.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had a pretty good body to go right with it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Damn! He needed to get a grip. This was business; she represented a client. Try telling that to his testosterone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shifted in the seat. “Public service is a bitch, though. Lousy pay, long hours. With your credentials, have you thought about finding a more lucrative job?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she didn’t immediately answer, he glanced her way again. The look she gave him could melt the tires out from under his truck. “Something wrong?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you mean that my job is a waste of my talents, I assure you that what I do matters. If you’d ever looked into the eyes of the child of a batterer, then you’d know what I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Believe me, Ms. Brailey, I have.” He’d been that child.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("She shot him a remorseful look, then shook her head. ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("“I’m sorry. I’m sure you have. I’m just a little testy when it comes to defending my reasons for staying with the shelter.”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was just speaking from personal experience.” But he wasn’t so jaded that he didn’t know exactly where she was coming from. Dealing with kids who were victims of adult brutality had never been easy. In fact, it had torn at his heart and had nearly destroyed his faith in humanity. People like Erin Brailey were few and far between. She reminded him that good did exist in this screwed-up world. And he admired her for her commitment, her passion for the cause. If only he could feel that way again—the way he’d felt before it had all come apart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zach didn’t know what to say or if he should just keep his mouth shut. He couldn’t help but wonder if Erin Brailey’s passion carried over into her personal life. Was she as all-fired enthusiastic about other things?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He might as well get “other things” out of his head if he wanted to remain objective. No problem. Control was one of his stronger suits. Under normal circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A few minutes later the truck crunched up the gravel drive leading to the shelter. The gate hung askew, the paint on the white frame house was blistering and peeling. Someone had finished painting the front facade but not all the way up to the second floor. From the looks of things, another month might not be enough time to get the place in shape.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zach barely put the truck into park before Erin opened the door and slid out. As he watched her walk toward the entrance, he realized she looked as good in back as she did in front. He got out of the truck muttering a litany of curses and cautions.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Zach entered the shelter but didn’t immediately see Erin. His booted heels echoed in the hall as he walked the well-")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("worn hardwood floor. At the end of the foyer he found Erin at the bottom of the stairs surveying a freshly painted wall.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is looking much better.” She faced him with a polite smile. “The bottom floor consists of mainly the manager’s quarters, a kitchen, a living room and a small den. All the bedrooms are upstairs. Where do you want to start?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He surveyed the surroundings, noting some places that looked vulnerable to a security breach. “Down here’s fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay.” She glanced up the stairs, then turned back to him. “You can start here, and I’ll be with you in a minute. If you don’t mind, I want to check on the second-floor children’s room and make sure it’s been done right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sudden softening of her features took Zach by surprise, and then he recalled her earlier comment about the kids. “The children’s room, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her smile was almost self-conscious, as if she’d been caught in some illicit act. “Don’t look so shocked, Mr. Miller. I admit I like kids. I work with them at the shelter with a self-esteem program. It’s important to break the cycle before they reach adulthood.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I understand.” More than she would ever know. Zach made a sweeping gesture toward the stairs. “By all means check it out. You can join me down here when you’re done.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks. I’ll be back in a while.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("After Erin departed up the stairs, Zach got busy surveying the rooms, checking the windows, making notes about his concerns. He listed all points of vulnerability and completed the initial evaluation and still he had yet to see Erin again. Although he would need to return at least one more time before getting started on the wiring, in case he missed ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("something, he was pretty much finished evaluating the first floor. Might as well go find Ms. Brailey.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He headed toward the staircase, shaking his head. Erin Brailey liked kids. He wouldn’t have guessed that about her, but then his instincts about women weren’t always correct. Those who appeared the toughest on the surface often hid their vulnerabilities from the world. He’d learned that the hard way. But Erin Brailey wasn’t a victim.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zach gripped the rickety banister and took the stairs two at a time. When he reached the top landing, the acrid smell of fresh paint assaulted his nostrils and burned his eyes. He moved down the hall, glancing into each room, one newly renovated, the other waiting its turn. He paused to consider what a place like this would have meant to his mother. Maybe things would have been different if she’d had the resources to change her life for the better. Maybe he would have been different. But that was the past, something Zach couldn’t alter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Continuing on, Zach found Erin in the third room beyond the staircase, a small bedroom decorated in a pastel blue with yellow rabbits bordering the wall where it met the ceiling. Normally he wouldn’t notice what the room looked like, but Erin Brailey’s fitted skirt contrasted with the walls like black leather against a backdrop of sky. She was standing on the top rung of a ladder in her stocking feet, reaching up where a piece of the bunny border had obviously come undone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could very well come undone if she didn’t get down off the blasted ladder. He had the strongest urge to go to her, run his hands up the sides of her sculpted thighs…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hold it right there, Miller.")]), _vm._v(" He streaked a hand over his eyes as if that could erase the image. Man, oh, man, he was in trouble. He should get out of here, go to his favorite bar and find himself a woman. Easier said than done. Erin ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Brailey, with the soft spot for kids and no-holds-barred confidence, held more appeal than any woman he could think of, past or present.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Need some help?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She regarded him over her shoulder. “No…I’m just about done.” She smoothed the border with one long tapered hand, then slapped it for good measure. “There. Good as new.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She backed down the rungs and once she reached the bottom, turned to face him. Using the ladder for balance, she slipped her heels back on and asked, “Did you get a good look?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hell, had he been that obvious? “At what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Downstairs. Did you see what you wanted to?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the moment he’d seen much more than he’d wanted to. Correction. Needed to. “Yeah. So if you’re through hanging paper, you could show me around up here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She brushed a few golden strands of hair away from her face with one hand. “I’m through for now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is paper hanging in your job description, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not exactly, but we’re lacking in volunteers. Considering the nature of this project, the fewer people who know the location, the better.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m pretty handy with a brush. Maybe I could help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Erin took two steps forward and studied him with eyes as blue as the sky blue walls. “I’m sure you have better ways to spend your time than painting an old house.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Actually, I don’t. After business hours, at least.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She raised a thin brow. “Your wife wouldn’t mind?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t have a wife.” Since she had broached the subject, he might as well ask. “How about you? Husband?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She twisted the ring on her right hand. “Heavens, no.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry subject?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("She brushed past him and stopped at the door. “You ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("know how it is, Mr. Miller. Priorities don’t always include the husband, two-point-five kids and a golden retriever.”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He moved to stand opposite her and braced a hip against the door frame. “Yeah, I know what you mean. But surely you don’t spend all your time at work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lately, yes. I haven’t found anything that captures my passion like my work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or anyone?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. Definitely not,” she said adamantly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zach clenched the back of his neck with one hand and studied the semiwhite drop cloth under his feet. “That’s a shame, Ms. Brailey. A real shame.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t feel sorry for me, Mr. Miller. I manage.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pity didn’t enter into it. She wasn’t the kind of woman a man felt sorry for. He met her gaze. Big mistake. “It’s Zach, and since neither of us seems to be occupied, do you want to grab a bite to eat? I could go over a few of my concerns.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sighed. “That sounds very tempting, but I’m afraid I have dinner plans. He’s probably already at the restaurant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A strong sense of disappointment assaulted Zach, not that he was one to give up that easily. He leaned forward and lowered his voice. “Someone special?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Actually, I’m having dinner with my father.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He straightened on that one. “You and your dad are close?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the time it took to blink, her expression went cold. “It’s an obligatory weekly dinner. That’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zach wondered about the sudden change in her demeanor but thought it wise not to pursue the topic. He understood all too well the complicated dynamics between parent and child. He’d hated his father and still did, even though the man was dead.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My father doesn’t like to be kept waiting,” she added. “So let’s go down the hall, Mr.—” Her mouth worked into a smile “—Zach.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She could make St. Peter sin with that smile. Which, as a practiced sinner, made Zach a goner. “At least we have the name thing straight. And let’s make another deal. We say what’s on our minds, no apologies. I think that works best with business arrangements.” He held out his hand. “Is it a deal?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After a moment’s hesitation, she grasped his hand. “Deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t immediately release her hand. Instead, he rubbed his thumb over her knuckles and met her eyes, surprise in their blue depths. Awareness sparked between them, keen as a razor’s edge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Checking back into reality, he dropped her hand. “Better wear gloves when you paint so you don’t ruin your hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She studied her hands as if she didn’t believe him. “Thanks for the advice, but I’m not that fragile.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, she probably wasn’t, but he’d give up a week’s salary to find out. He might even throw in his season hockey tickets.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zach pushed off the door thinking he’d best escape before he did something stupid. “Well, Ms. Brailey—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s Erin. Turnabout’s fair play.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He grinned. “Okay, Erin, we should look around so you’re not late for your dinner date.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re right. Can’t keep Daddy waiting.” Her tone was laced with sarcasm.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("They walked the hall, and before they reached the next room, Erin turned back to him. “Since this tour is going to have to be quick, why don’t you come by my office ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("tomorrow? You can bring the blueprint and show me your ideas.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zach slipped his hands into his pockets, all too eager to accept. “Morning okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m afraid it will have to be later. I visit the other shelter in the mornings, and I have a board meeting at four-thirty. You could meet me after that in the boardroom. That way we’ll have access to the conference table.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A burst of heat shot through him at the thought of what he would like to do with her on top of that table. The image came to him sharp and clear and totally unexpected. What was it about her that had his fantasies running away with his common sense? It was physical, yes, but there was more. That bothered him. He could control animal lust, but he didn’t like to deal with human need. He suspected Erin was the kind of woman who could make him reveal his darkest secrets, if he wasn’t careful. He couldn’t afford to open old wounds. “What time?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She started back down the hall. “Six.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zach lagged behind so he could enjoy the view. “Good. I’ll bring dinner. Chinese okay with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Great.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you like?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Spicy,” she said without turning around, but he detected a smile in her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If she only knew what she was doing to him, she’d probably prefer to walk back. But maybe not. Maybe she did inject passion into everything she attempted. Something told him he just might have to find out.")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page21"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fb60256","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459206625_ch01.vue
// module id = 81
// module chunks = 0